<template>
  <div id="highlight-banner" class="sokal-py-3" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="banner-frame sokal-flex sokal-gap">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path d="M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M30 30H18M30 30V18M30 30L18 18" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <div class="banner-text">
        <h4>We've got some great deals that give you more savings!</h4>
        <p>Start shopping our lowest priced deals today.</p>
      </div>
      <a class="highlight-banner-btn" href="/newvehiclespecials">
        Shop Specials
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="17" cy="17" r="17" transform="rotate(90 17 17)" fill="currentColor"/>
          <path d="M11.1667 17H22.8334" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17 11.1665L22.8334 16.9998L17 22.8332" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";

  export default {
    data() {
      return {
        brand: this.$store.state.chosenBrand
      }
    },
    computed: {
      getBrand () {
        return this.brand;
      }
    }
  }
</script>

<style scoped>
  #highlight-banner[data-brand="ford"] {
    background: radial-gradient(circle, rgba(6, 111, 239, 0.18) 0%, rgba(6, 111, 239, 0.05) 45%, rgba(255, 255, 255, 0.9) 80%, rgba(255, 255, 255, 1) 100%);
    --primary-color: var(--secondary-color) !important;
  }

  #highlight-banner .banner-frame {
    border: 2px solid #E5E5E5;
    background: rgba(255, 255, 255, 0.50);
    backdrop-filter: blur(10px);
    border-radius: 10px;
    padding: 12px;
    margin: 15px;
    align-items: center;
  }
  #highlight-banner .banner-frame svg path {
    stroke: var(--primary-color);
  }

  #highlight-banner .banner-frame .highlight-banner-btn {
    margin-left: auto;
    border-radius: 10px;
    border: 2px solid var(--primary-color);
    background: var(--primary-color);
    backdrop-filter: blur(10px);
    color: #ffffff;
    display: flex;
    padding: 15px;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    font-size: 1.25rem;
    font-weight: 700;
    -webkit-transition: opacity 0.2s linear;
    transition: opacity 0.2s linear;
  }
  #highlight-banner .banner-frame .highlight-banner-btn:hover,
  #highlight-banner .banner-frame .highlight-banner-btn:focus {
    opacity: 0.7;
  }

  /* CJDR */
  .layout[data-component="Interaction Bar with Search v Luxury"] + .layout[data-component="Highlight Banner"] #highlight-banner[data-brand="cjdr"] {
    padding: 0 0 25px;
  }
  #highlight-banner[data-brand="cjdr"] .banner-frame .highlight-banner-btn {
    background: var(--primary-dark);
    border-color: var(--primary-dark);
    font-family: "Barlow Condensed", sans-serif;
    font-weight: 700;
    font-style: normal;
    text-transform: uppercase;
  }

  #highlight-banner[data-brand="cjdr"] .banner-frame .highlight-banner-btn svg circle {
    fill: var(--primary-color);
  }

  #highlight-banner[data-brand="cjdr"] .banner-frame .highlight-banner-btn svg path {
    stroke: var(--primary-light);
  }

  #highlight-banner .banner-text p {
    font-size: 1rem;
    margin-bottom: 0;
  }

  #highlight-banner .banner-text h4 {
    font-weight: 600;
    margin-bottom: 10px;
    font-size: 16px;
  }

  @media (min-width: 576px) and (max-width: 767px) {
    .banner-text {
      max-width: 40%;
    }
  }

  @media (max-width: 575px) {
    #highlight-banner .banner-frame {
      flex-direction: column;
      align-items: start;
    }
    #highlight-banner .banner-frame .highlight-banner-btn {
      width: 100%;
      margin-left: 0;
      justify-content: center;
    }
  }
</style>